import React from "react";
import { Navigate, Route, Routes } from "react-router";

import Login from "../../screens/Profile/Login";
import Register from "../../screens/Profile/Register";
import PwForgot from "../../screens/Profile/PwForgot";
import Profile from "../../screens/Profile";
import TeamManagement from "../../screens/TeamManagement";
import HomePage from "../../screens/Home";
import MatchPage from "../../screens/Match";
import LeaguePage from "../../screens/League";
import LoginPending from "../../screens/Profile/LoginPending";
import Imprint from "../../screens/Imprint";
import PlayerAppInfo from "../../screens/PlayerAppInfo";
import TeamPage from "../../screens/TeamPage";
import PlayerPage from "../../screens/PlayerPage";
import AllNews from "../../screens/AllNews";
import { isRegistered } from "../../../config/utils";
import { User } from "../../../client/api";
import {
  HomeDefaultRedirect,
  MatchDefaultRedirect,
  TeamLegacyRedirect
} from "./redirects";

type MainRoutesProps = {
  user: User;
};

const MainRoutes: React.FC<MainRoutesProps> = ({ user }) => (
  <Routes>
    <Route path="/" key="Home" element={<Navigate to="/home" replace />} />
    <Route path="/home" key="Home" element={<HomeDefaultRedirect />} />
    <Route path="/home/" key="Home" element={<HomeDefaultRedirect />} />
    <Route path="/home/date/:date" key="Home" element={<HomePage />} />
    <Route
      path="/profile"
      key="Profile"
      element={isRegistered(user) ? <Profile /> : <Navigate to="/login" replace />}
    />
    <Route path="/team/management" element={<TeamManagement />} />
    <Route
      path="/login"
      element={isRegistered(user) ? <Navigate to="/home" replace /> : <Login />}
    />
    <Route
      path="/login/:redirectAfter"
      element={isRegistered(user) ? <Navigate to="/home" replace /> : <Login />}
    />
    <Route
      path="/register"
      element={isRegistered(user) ? <Navigate to="/home" replace /> : <Register />}
    />
    <Route
      path="/register/:redirectAfter"
      element={isRegistered(user) ? <Navigate to="/home" replace /> : <Register />}
    />
    <Route
      path="/login/pending/:identifier"
      element={isRegistered(user) ? <Navigate to="/home" replace /> : <LoginPending />}
    />
    <Route
      path="/login/pending/:identifier/:redirectAfter"
      element={isRegistered(user) ? <Navigate to="/home" replace /> : <LoginPending />}
    />
    <Route
      path="/pw-forgot"
      element={isRegistered(user) ? <Navigate to="/home" replace /> : <PwForgot />}
    />
    <Route
      path="/pw-forgot/:redirectAfter"
      element={isRegistered(user) ? <Navigate to="/home" replace /> : <PwForgot />}
    />
    <Route path="/imprint" element={<Imprint />} />
    <Route path="/team/:teamId" element={<TeamPage />} />
    <Route path="/team/:teamId/:view" element={<TeamPage />} />
    <Route path="/match/:matchId/team/:teamId" element={<TeamLegacyRedirect />} />
    <Route path="/match/:matchId/team/:teamId/:view" element={<TeamLegacyRedirect />} />
    <Route path="/match/:matchId" element={<MatchDefaultRedirect />} />
    <Route path="/match/:matchId/:view" element={<MatchPage />} />
    <Route path="/league/:leagueId" element={<LeaguePage />} />
    <Route path="/league/:leagueId/:view" element={<LeaguePage />} />
    <Route path="/player/app" element={<PlayerAppInfo />} />
    <Route path="/player/:playerId" element={<PlayerPage />} />
    <Route path="/news" element={<AllNews />} />
    <Route path="*" element={<Navigate to="/home" replace />} />
  </Routes>
);

export default MainRoutes;

